// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Subscribe Container */
.subscribe-container {
  display: flex;
  justify-content: flex-end;
  margin: 0;
  padding: 0;
  width: auto;
}

/* Subscribe Button - Desktop */
.subscribe-button {
  background-color: #35495E;
  color: white;
  border: none;
  border-radius: 8px;
  height: 40px;
  width: auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
  line-height: 1;
}

.subscribe-text {
  position: relative;
  top: 1px; /* nudge text down slightly for optical center */
}

.subscribe-button:hover {
  background-color: #2c3e50;
  transform: translateY(-1px);
  cursor: pointer;
}



.subscribe-button:hover {
  background-color: #2c3e50;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

/* Mobile Button Specific Styles */
.mobile-button {
  width: 40px !important;
  height: 40px !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 !important;
  box-shadow: none !important;
  vertical-align: middle;
  border-radius: 6px;
}


/* Modal Overlay */
.subscribe-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Container */
.subscribe-modal {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

/* Modal Header */
.subscribe-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.subscribe-modal-header h2 {
  margin: 0;
  color: #35495E;
  font-size: 1.5rem;
}

.close-modal-button {
  background: none;
  border: none;
  font-size: 24px;
  color: #777;
  cursor: pointer;
}

.close-modal-button:hover {
  color: #333;
  cursor: pointer;
}

/* Modal Content */
.subscribe-modal-content {
  padding: 20px;
}

/* Form Elements */
.form-group {
  margin-bottom: 20px;
  width: 100%;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
}

.form-group input[type="text"],
.form-group input[type="email"],
.form-group select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #35495E;
  box-shadow: 0 0 0 2px rgba(53, 73, 94, 0.1);
}

.category-dropdown > label {
  margin: 0 !important;
}
/* Category Checkboxes */
.category-checkboxes {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
}

.category-checkbox {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 0;
  white-space: nowrap;
}

.category-checkbox input[type="checkbox"] {
  margin: 0;
}

.category-checkbox label {
  margin-bottom: 0;
  font-weight: normal;
}

/* Form Actions */
.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
}

.submit-button {
  background-color: #35495E;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  max-width: 200px;
}

.submit-button:hover {
  background-color: #2c3e50;
  cursor: pointer;
}

.submit-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Notification Messages */
.message {
  padding: 10px;
  margin: 15px 0;
  border-radius: 4px;
  text-align: center;
}

.message.success {
  background-color: #e7f7e7;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
}

.message.error {
  background-color: #fdecea;
  color: #c62828;
  border: 1px solid #ffcdd2;
}

/* Blog Header Styles - For proper alignment */
.blog-header {
  display: flex;
  align-items: center;       /* ✅ align vertically */
  justify-content: space-between;
  background: #fff;
  padding: 10px 24px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  height: auto;              /* ✅ let it wrap naturally */
}

.nav-home-container,
.subscribe-container-wrapper {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
}

.subscribe-container-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;     /* ✅ force same as button */
  width: auto;
  padding: 0;
  margin: 0;
}



.rss-feed-title {
  flex-grow: 1;
  text-align: center;
  font-size: 28px;
  color: #35495E;
  margin: 0;
  white-space: nowrap;
}

/* Responsive Styles
@media (max-width: 667px) {
  .rss-feed-title {
    font-size: 22px;
  }

  .category-dropdown {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 15px;
    gap: 10px;
  }

  .category-dropdown label {
    margin-right: 10px;
    white-space: nowrap;
  }

  .category-dropdown select {
    min-width: 150px;
  }

  .category-checkboxes {
    grid-template-columns: 1fr;
  }

  .form-actions {
    flex-direction: column;
    align-items: center;
  }

  .submit-button {
    width: 100%;
  }

  .subscribe-modal {
    width: 95vw;
  }
} */`, "",{"version":3,"sources":["webpack://./src/Subscribe.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ,EAAE,gDAAgD;AAC5D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;;;;AAIA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;EACzC,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;AACpB;;;AAGA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;AACtB;AACA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB,QAAQ,uBAAuB;EAClD,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY,eAAe,4BAA4B;AACzD;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,MAAM,2BAA2B;EAC7C,WAAW;EACX,UAAU;EACV,SAAS;AACX;;;;AAIA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAuCG","sourcesContent":["/* Subscribe Container */\n.subscribe-container {\n  display: flex;\n  justify-content: flex-end;\n  margin: 0;\n  padding: 0;\n  width: auto;\n}\n\n/* Subscribe Button - Desktop */\n.subscribe-button {\n  background-color: #35495E;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  height: 40px;\n  width: auto;\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  font-weight: 500;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease;\n  line-height: 1;\n}\n\n.subscribe-text {\n  position: relative;\n  top: 1px; /* nudge text down slightly for optical center */\n}\n\n.subscribe-button:hover {\n  background-color: #2c3e50;\n  transform: translateY(-1px);\n  cursor: pointer;\n}\n\n\n\n.subscribe-button:hover {\n  background-color: #2c3e50;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n}\n\n/* Mobile Button Specific Styles */\n.mobile-button {\n  width: 40px !important;\n  height: 40px !important;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  margin: 0 !important;\n  box-shadow: none !important;\n  vertical-align: middle;\n  border-radius: 6px;\n}\n\n\n/* Modal Overlay */\n.subscribe-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Modal Container */\n.subscribe-modal {\n  background-color: white;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n/* Modal Header */\n.subscribe-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.subscribe-modal-header h2 {\n  margin: 0;\n  color: #35495E;\n  font-size: 1.5rem;\n}\n\n.close-modal-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #777;\n  cursor: pointer;\n}\n\n.close-modal-button:hover {\n  color: #333;\n  cursor: pointer;\n}\n\n/* Modal Content */\n.subscribe-modal-content {\n  padding: 20px;\n}\n\n/* Form Elements */\n.form-group {\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #333;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"email\"],\n.form-group select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #35495E;\n  box-shadow: 0 0 0 2px rgba(53, 73, 94, 0.1);\n}\n\n.category-dropdown > label {\n  margin: 0 !important;\n}\n/* Category Checkboxes */\n.category-checkboxes {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 10px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.category-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 0;\n  white-space: nowrap;\n}\n\n.category-checkbox input[type=\"checkbox\"] {\n  margin: 0;\n}\n\n.category-checkbox label {\n  margin-bottom: 0;\n  font-weight: normal;\n}\n\n/* Form Actions */\n.form-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.submit-button {\n  background-color: #35495E;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 12px 24px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  width: 100%;\n  max-width: 200px;\n}\n\n.submit-button:hover {\n  background-color: #2c3e50;\n  cursor: pointer;\n}\n\n.submit-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n/* Notification Messages */\n.message {\n  padding: 10px;\n  margin: 15px 0;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.message.success {\n  background-color: #e7f7e7;\n  color: #2e7d32;\n  border: 1px solid #c8e6c9;\n}\n\n.message.error {\n  background-color: #fdecea;\n  color: #c62828;\n  border: 1px solid #ffcdd2;\n}\n\n/* Blog Header Styles - For proper alignment */\n.blog-header {\n  display: flex;\n  align-items: center;       /* ✅ align vertically */\n  justify-content: space-between;\n  background: #fff;\n  padding: 10px 24px;\n  width: 100%;\n  box-sizing: border-box;\n  border-bottom: 1px solid #eee;\n  height: auto;              /* ✅ let it wrap naturally */\n}\n\n.nav-home-container,\n.subscribe-container-wrapper {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n}\n\n.subscribe-container-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;     /* ✅ force same as button */\n  width: auto;\n  padding: 0;\n  margin: 0;\n}\n\n\n\n.rss-feed-title {\n  flex-grow: 1;\n  text-align: center;\n  font-size: 28px;\n  color: #35495E;\n  margin: 0;\n  white-space: nowrap;\n}\n\n/* Responsive Styles\n@media (max-width: 667px) {\n  .rss-feed-title {\n    font-size: 22px;\n  }\n\n  .category-dropdown {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px 15px;\n    gap: 10px;\n  }\n\n  .category-dropdown label {\n    margin-right: 10px;\n    white-space: nowrap;\n  }\n\n  .category-dropdown select {\n    min-width: 150px;\n  }\n\n  .category-checkboxes {\n    grid-template-columns: 1fr;\n  }\n\n  .form-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .submit-button {\n    width: 100%;\n  }\n\n  .subscribe-modal {\n    width: 95vw;\n  }\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
